/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module McpserverTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Mcpserver {
    [k: string]: any;
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "GetStatusReturn".
 */
export interface GetStatusReturn {
    /**
     * MCP server identity name (e.g. nvidia-app)
     */
    server_name?: string;
    running?: boolean;
    /**
     * Active stdio/pipe client count
     */
    stdio_connections?: number;
    /**
     * Active HTTP client count
     */
    http_connections?: number;
    http_url?: string;
    bridge_path?: string;
    access_level?: AccessLevel;
    connected_clients?: {
        name?: string;
        version?: string;
        protocol?: string;
        transport?: Transport;
        /**
         * Resolved access role (e.g. readonly, standard, full_access)
         */
        role?: string;
        authenticated?: boolean;
        /**
         * Milliseconds elapsed since last request; absent for persistent legacy connections
         */
        last_seen_age_ms?: number;
    }[];
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "GetMcpServerToolsReturn".
 */
export interface GetMcpServerToolsReturn {
    tools?: {
        name?: string;
        description?: string;
        access_level?: AccessLevel;
    }[];
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "SetAccessLevelParameters".
 */
export interface SetAccessLevelParameters {
    access_level: AccessLevel;
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "McpOverlayToolCallNotificationReturn".
 */
export interface McpOverlayToolCallNotificationReturn {
    /**
     * Correlation id for the tool call
     */
    requestId: string;
    /**
     * MCP tool name
     */
    name: string;
    /**
     * Tool arguments from MCP tools/call
     */
    arguments: {
        [k: string]: any;
    };
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "SendMcpOverlayToolResponseParameters".
 */
export interface SendMcpOverlayToolResponseParameters {
    /**
     * Correlation id matching McpOverlayToolCallNotification
     */
    requestId: string;
    status: Status;
    /**
     * Human-readable result or error message
     */
    message: string;
    /**
     * Optional structured result data
     */
    data?: {
        [k: string]: any;
    };
    /**
     * Machine-readable error code when status is error
     */
    errorCode?: string | null;
    /**
     * Whether the MCP client may retry the tool call
     */
    retriable: boolean;
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "McpGameEventNotificationParameters".
 */
export interface McpGameEventNotificationParameters {
    eventType: EventType;
    /**
     * Display name of the game
     */
    gameName?: string;
    /**
     * OS process ID of the game
     */
    processId?: number;
    /**
     * Whether the game is in fullscreen mode
     */
    fullscreen?: boolean;
    /**
     * ISO 8601 timestamp of the event
     */
    timestamp?: string;
}
/**
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "McpOverlayStateChangedNotificationParameters".
 */
export interface McpOverlayStateChangedNotificationParameters {
    category: Category;
    /**
     * Updated state snapshot for the changed category
     */
    state?: {
        [k: string]: any;
    };
    /**
     * ISO 8601 timestamp of the state change
     */
    timestamp?: string;
}

/**
 * MCP server access level (readonly = safe tools only, standard = safe + normal, full_access = all tools)
 *
 * This interface was referenced by `Mcpserver`'s JSON-Schema
 * via the `definition` "AccessLevel".
 */
export enum AccessLevel {
    readonly = 'readonly',
    standard = 'standard',
    full_access = 'full_access'
}
export enum Transport {
    stdio = 'stdio',
    http = 'http'
}
/**
 * Tool execution outcome
 */
export enum Status {
    success = 'success',
    error = 'error'
}
/**
 * Game lifecycle event type
 */
export enum EventType {
    game_started = 'game_started',
    game_exited = 'game_exited',
    fullscreen_entered = 'fullscreen_entered',
    fullscreen_exited = 'fullscreen_exited'
}
/**
 * Which overlay subsystem changed
 */
export enum Category {
    capture = 'capture',
    recording = 'recording',
    filters = 'filters',
    stats = 'stats',
    audio = 'audio',
    hotkeys = 'hotkeys',
    storage = 'storage',
    notifications = 'notifications'
}


}
